import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import LoginPage from '../auth/pages/LoginPage';
import { selectIsAppConfigAvailable, selectIsAppConfigLoading } from '../core/config-loader/store/config-loader-slice';
import FullPageLoaderPage from '../core/pages/FullPageLoaderPage';
import { APP_ROUTE_PATHS } from './appRoutes';

export default function usePublicRoutes() {
  const isAppConfigAvailable = useSelector(selectIsAppConfigAvailable);
  const isAppConfigLoading = useSelector(selectIsAppConfigLoading);

  return [
    {
      path: APP_ROUTE_PATHS.LOGIN,
      element: isAppConfigLoading ? (
        <FullPageLoaderPage />
      ) : (
        <Suspense fallback={<FullPageLoaderPage />}>{isAppConfigAvailable ? <LoginPage /> : 'App config not provided!'}</Suspense>
      ),
    },
    { path: '*', element: <Navigate to={APP_ROUTE_PATHS.LOGIN} replace /> },
  ];
}
